<template>
  <div>
    <text-dialog :value.sync="playingMedia" :title="mediaDialogTitle">
      <div slot="content">
        <video
          v-if="playingMedia && mediaURL.includes('.mp4')"
          :src="mediaURL"
          autoplay
          controls
          style="
            max-width: 560px;
            max-height: 315px;
            display: block;
            margin: auto;
          "
        >
          Ihr Browser unterstützt keine Videodateien
        </video>
        <audio
          v-else-if="playingMedia"
          :src="mediaURL"
          autoplay
          controls
          style="display: block; margin: auto"
        >
          Ihr Browser unterstützt keine Audiodateien
        </audio>
      </div>
    </text-dialog>

    <v-toolbar class="elevation-0" color="#ffffff" height="64">
      <v-toolbar-title>
        <span class="hidden-xs-only">Gesamt:&nbsp;</span>{{ sum }}
      </v-toolbar-title>

      <v-spacer v-if="!$vuetify.breakpoint.xs"></v-spacer>
      <v-spacer v-if="!$vuetify.breakpoint.xs"></v-spacer>

      <v-select
        ref="invoiceSelect"
        v-show="event && event.generate_invoices"
        :items="currentInvoices"
        :disabled="currentInvoices.length === 0 || selectedInvoice !== null"
        :loading="selectedInvoice !== null"
        return-object
        item-text="invoice_number"
        item-value="id"
        label="Rechnung herunterladen"
        outline
        class="invoices"
        v-model="selectedInvoice"
      >
      </v-select>
      <!--<v-menu v-show="event && event.generate_invoices" :nudge-width="100" :disabled="currentInvoices.length === 0">
                <v-toolbar-title slot="activator">
                    <span>Rechnungen</span>
                    <v-icon>arrow_drop_down</v-icon>
                </v-toolbar-title>

                <v-list>
                    <v-list-tile v-for="invoice in currentInvoices" :key="invoice.id" @click="downloadInvoice(invoice)">
                        <v-list-tile-title>{{ 'Rechnung-' + invoice.invoice_number + '.pdf' }}</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>-->
    </v-toolbar>

    <item-list
      v-if="format === 'starters'"
      :items="selectedRegistrations"
      :data-table-config="dataTableConfig"
      :actions="actions"
      :tooltips="tooltips"
      :showProgress="uploadingMedia"
      :progress="uploadingMediaProgress"
      actions-first
      :lock-actions="lockActions"
      show-actions
      elevation="0"
      :header="sum"
    >
      <template slot="header">
        <v-btn
          flat
          :block="$vuetify.breakpoint.xs"
          :disabled="printing"
          :loading="printing"
          outline
          @click="print"
          v-show="selectedRegistrations.items.length > 0"
          >{{ $t("download_overview")
          }}<!--&nbsp;<v-icon>cloud_download</v-icon>--></v-btn
        >
      </template>
    </item-list>

    <item-list
      v-else-if="format === 'dancers'"
      :items="selectedRegistrationDancers"
      :data-table-config="dataTableConfigDancers"
      :actions="actions"
      :tooltips="tooltips"
      :lock-actions="lockActions"
      show-actions
      :header="sum"
    >
      <template slot="header">
        <v-btn
          flat
          :disabled="printing"
          :loading="printing"
          outline
          @click="print"
          v-show="selectedRegistrations.items.length > 0"
          >{{ $t("download_overview")
          }}<!--&nbsp;<v-icon>cloud_download</v-icon>--></v-btn
        >
      </template>
    </item-list>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ItemList from "../common/ItemList";
import jsPDF from "jspdf";
import autotable from "jspdf-autotable";
import TextDialog from "../dialogs/TextDialog";

export default {
  components: {
    "item-list": ItemList,
    "text-dialog": TextDialog,
  },
  props: {
    event: {
      type: Object,
      default: null,
    },
    format: {
      type: String,
      default: "starters",
    },
    uploading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      invoices: [],
      selectedInvoice: null,
      currentInvoices: [],
      printing: false,
      lockActions: false,
      uploadingMedia: false,
      uploadingMediaProgress: 0,
      mediaURL: "",
      playingMedia: false,
      mediaDialogTitle: "",
      selectedRegistrations: {
        loaded: true,
        items: [],
      },
      selectedRegistrationDancers: {
        loaded: true,
        items: [],
      },
      downloading: false,
      dataTableConfig: {
        loadingDataText: "Lade Meldungen",
        noDataText: "Keine Meldungen verfügbar",
        rowsPerPageText: "Zeilen pro Seite",
        headers: [
          { text: "Starter", value: "name", align: "left" },
          { text: "Typ", value: "starter_type.name", align: "left" },
          {
            text: this.$t("age_group"),
            value: "age_group.name",
            align: "left",
          },
          { text: "Style", value: "starter_style.name", align: "left" },
          { text: "Meldedatum", value: "created_at", align: "left" },
          { text: this.$t("price"), value: "price_sum", align: "left" },
        ],
        items: {
          large: [
            { value: "name" },
            { value: "starter_type.name", translate: true },
            { value: "age_group.name" },
            { value: "starter_style.name" },
            { value: "created_at", formatFunction: "$formatDate" },
            { value: "price_sum", formatFunction: "$currency" },
          ],
          small: [
            { value: "name" },
            // {value: 'starter_style.name'},
            // {value: 'price_sum', formatFunction: '$currency'}
          ],
        },
      },
      dataTableConfigDancers: {
        loadingDataText: "Lade Meldungen",
        noDataText: "Keine Meldungen verfügbar",
        rowsPerPageText: "Zeilen pro Seite",
        headers: [
          {
            text: this.$t("first_name"),
            value: "member.first_name",
            align: "left",
          },
          {
            text: this.$t("last_name"),
            value: "member.last_name",
            align: "left",
          },
          { text: "Starter", value: "name", align: "left" },
          { text: "Typ", value: "starter_type.name", align: "left" },
          {
            text: this.$t("age_group"),
            value: "age_group.name",
            align: "left",
          },
          { text: "Style", value: "starter_style.name", align: "left" },
          { text: "Meldedatum", value: "created_at", align: "left" },
          { text: this.$t("price"), value: "member.price", align: "left" },
        ],
        items: {
          large: [
            { value: "member.first_name" },
            { value: "member.last_name" },
            { value: "name" },
            { value: "starter_type.name", translate: true },
            { value: "age_group.name" },
            { value: "starter_style.name" },
            { value: "created_at", formatFunction: "$formatDate" },
            { value: "member.price", formatFunction: "$currency" },
          ],
          small: [
            { value: "member.first_name" },
            { value: "member.last_name" },
            { value: "starter_style.name" },
            { value: "member.price", formatFunction: "$currency" },
          ],
        },
      },
      tooltips: [
        {
          visible: (registration) => {
            return registration.needs_media && !registration.has_media;
          },
          label: this.$t("missing_music"),
          color: "yellow",
          icon: "music_off",
        },
        {
          visible: (registration) => {
            return registration.needs_media && registration.has_media;
          },
          label: this.$t("music_uploaded"),
          color: "green",
          icon: "music_note",
        },
        {
          visible: (registration) => {
            return this.event.generate_invoices && registration.is_paid;
          },
          label: this.$t("paid"),
          color: "green",
          icon: "attach_money",
        },
        {
          visible: (registration) => {
            return this.event.generate_invoices && !registration.is_paid;
          },
          label: this.$t("unpaid"),
          color: "grey",
          icon: "money_off",
        },
      ],
      actions: [
        //Play Media Button
        {
          visible: (registration) => {
            if (
              registration.hasOwnProperty("loadingMedia") &&
              registration.loadingMedia
            ) {
              return true;
            }

            return this.format === "starters" && registration.has_media;
          },
          disabled: (registration) => {
            return (
              registration.hasOwnProperty("loadingMedia") &&
              registration.loadingMedia
            );
          },
          loading: (registration) => {
            return (
              registration.hasOwnProperty("loadingMedia") &&
              registration.loadingMedia
            );
          },
          label: this.$t("play_music"),
          icon: "play_arrow",
          click: (registration) => {
            let user = JSON.parse(localStorage.getItem("user"));
            this.mediaURL = `/meldeportal/api/v1/event_registrations/${registration.id}/media-stream?api_token=${user.api_token}`;
            this.mediaDialogTitle = `Musik/Video zu Starter ${registration.name}`;
            this.playingMedia = true;
          },
        },
        //Upload Media Button
        {
          visible: (registration) => {
            return (
              this.format === "starters" &&
              registration.needs_media &&
              !registration.has_media &&
              (this.$hasRole("admin") || registration.can_change_media)
            );
          },
          loading: (registration) => {
            return this.uploadingMedia;
          },
          label: this.$t("upload_music"),
          icon: "file_upload",
          click: this.uploadMedia,
        },
        //Replace Music Button
        {
          visible: (registration) => {
            return (
              this.format === "starters" &&
              registration.needs_media &&
              registration.has_media &&
              (this.$hasRole("admin") || registration.can_change_media)
            );
          },
          loading: (registration) => {
            return this.uploadingMedia;
          },
          label: this.$t("upload_new_music"),
          icon: "file_upload",
          click: this.uploadMedia,
        },
      ],
    };
  },
  computed: {
    sum() {
      if (!this.selectedRegistrations.loaded) {
        return "0,00 €";
      }

      let registrations = _.filter(this.selectedRegistrations.items, (r) => {
        return r.deleted_at === null;
      });

      let sum = _.sumBy(registrations, "price_sum");

      return this.$n(sum / 100, "currency");
    },
    ...mapState(["registrations", "events", "cache"]),
  },
  watch: {
    selectedInvoice() {
      if (this.selectedInvoice === null) {
        return;
      }

      this.downloadInvoice(this.selectedInvoice);
    },
  },
  mounted() {
    this.loadRegistrations(this.event.id);

    this.loadInvoices();
  },
  methods: {
    loadRegistrations(eventId) {
      if (this.selectedRegistrations.items.length > 0) {
        this.$set(this.selectedRegistrations, "items", []);
        this.$set(this.selectedRegistrationDancers, "items", []);
      }

      let eventRegistrations = _.reject(this.registrations.items, (r) => {
        return r.event_id !== eventId;
      });

      _.each(eventRegistrations, (r) => {
        this.selectedRegistrations.items.push(r);

        _.each(r.event_registration_members, (m) => {
          let copy = _.cloneDeep(r);
          delete copy.event_registration_members;
          delete copy.deleted_event_registration_members;
          copy.member = m;
          this.selectedRegistrationDancers.items.push(copy);
        });
        _.each(r.deleted_event_registration_members, (m) => {
          let copy = _.cloneDeep(r);
          delete copy.event_registration_members;
          delete copy.deleted_event_registration_members;
          copy.member = m;
          copy.deleted_at = m.deleted_at;

          this.selectedRegistrationDancers.items.push(copy);
        });
      });
    },
    loadInvoices() {
      axios.get("/api/v1/invoices").then((response) => {
        if (!response.data.success) {
          return;
        }

        this.$set(this, "invoices", response.data.data);

        this.selectCurrentInvoices();
      });
    },
    selectCurrentInvoices() {
      let invoices = [];
      _.each(this.invoices, (i) => {
        if (this.event.id === i.event_id) {
          invoices.push(i);
        }
      });

      this.$set(this, "currentInvoices", invoices);
    },
    downloadInvoice(invoice) {
      this.downloading = true;

      axios({
        url: `/api/v1/invoices/download/${invoice.id}`,
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Rechnung-${invoice.invoice_number}.pdf`);
        document.body.appendChild(link);
        link.click();

        this.downloading = false;
        this.selectedInvoice = null;
        this.$refs.invoiceSelect.blur();

        this.$store.commit("snackBar", {
          color: "success",
          text: this.$t("invoice_success"),
        });
      });
    },
    print() {
      this.printing = true;

      let columns =
        this.format === "starters"
          ? ["Starter", "Typ", "Altersklasse", "Style", "Meldedatum", "Gebühr"]
          : [
              "Vorname",
              "Nachname",
              "Starter",
              "Typ",
              "Altersklasse",
              "Style",
              "Meldedatum",
              "Gebühr",
            ];
      let rows = [];

      if (this.format === "starters") {
        _.each(this.selectedRegistrations.items, (r) => {
          rows.push([
            r.name,
            this.$t(r.starter_type.name),
            r.age_group.name,
            r.starter_style !== null ? r.starter_style.name : "",
            this.$formatDate(r.created_at),
            this.$currency(r.price_sum, true),
          ]);
        });
      } else {
        _.each(this.selectedRegistrationDancers.items, (r) => {
          rows.push([
            r.member.first_name,
            r.member.last_name,
            r.name,
            this.$t(r.starter_type.name),
            r.age_group.name,
            r.starter_style !== null ? r.starter_style.name : "",
            this.$formatDate(r.created_at),
            this.$currency(r.member.price, true),
          ]);
        });
      }

      let doc = new jsPDF("p", "pt");

      doc.autoTable({
        head: [columns],
        body: rows,
        styles: {
          fontSize: 10,
          overflow: "linebreak",
        },
      });

      doc.save(`Meldungen_${this.event.name}.pdf`);

      this.printing = false;
    },
    uploadMedia(registration) {
      let fileSelector = document.createElement("input");
      fileSelector.setAttribute("type", "file");
      // fileSelector.setAttribute('accept', '.mp3,.m4a,.wav,.mov,.mp4,.avi');
      fileSelector.setAttribute("accept", ".mp3,.wav,.mp4,.m4a");

      fileSelector.addEventListener("change", (event) => {
        this.lockActions = this.uploadingMedia = true;
        this.$emit("update:uploading", this.uploadingMedia);
        this.uploadingMediaProgress = 0;

        let file = event.target.files[0];

        let formData = new FormData();
        formData.append("media", file);

        this.$store.commit("snackBar", {
          color: "info",
          text: this.$t("music_is_uploading"),
        });

        axios
          .post(
            `/api/v1/event_registrations/${registration.id}/media`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
              onUploadProgress: (progressEvent) => {
                this.uploadingMediaProgress = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total,
                );
              },
            },
          )
          .then(
            (response) => {
              if (!response.data.success) {
                this.$store.commit("snackBar", {
                  color: "error",
                  text: this.$t("music_uploaded_error"),
                });
                this.lockActions = this.uploadingMusic = false;
                this.$emit("update:uploading", this.uploadingMedia);
                return;
              }

              this.$store.commit("snackBar", {
                color: "success",
                text: this.$t("music_uploaded_success"),
              });

              this.$store.commit("updateRegistration", response.data.data);

              registration.has_media = response.data.data.has_media;

              this.lockActions = this.uploadingMedia = false;
              this.$emit("update:uploading", this.uploadingMedia);
            },
            (errorResponse) => {
              console.error(errorResponse);
              this.$store.commit("snackBar", {
                color: "error",
                text: this.$t("music_uploaded_error"),
              });
              this.lockActions = this.uploadingMedia = false;
              this.$emit("update:uploading", this.uploadingMedia);
            },
          );
      });

      fileSelector.click();
    },
  },
};
</script>

<style scoped>
.invoices {
  width: 0;
}

.v-select.v-text-field--enclosed:not(.v-text-field--single-line)
  .v-select__selections {
  padding-top: 0 !important;
}

audio {
  outline: none;
  width: 100%;
}
</style>
